module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dropdown-button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.createMenu(_vm.getMenuContent)
      }
    }
  }, [_vm._t("menu_trigger")], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0234b981!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/material/components/plMenu/plMenu.vue
// module id = 1235
// module chunks = 61